import { API } from "../api";
import { url as URL } from "../constants";
import { IProductData, IProductResponse } from "./types";

export class ProductAPIService {
  constructor(private api: API) {}

  public async getAll(params?: any): Promise<IProductData> {
    const response = await this.api.get<IProductResponse>(URL.product.base, {
      params,
    });
    return response?.data?.items ?? [];
  }
}
